import React from "react";
import "./style.scss";

const BoxContent = ({ children, gap }) => {
  return (
    <div className={"box-content"} style={{ rowGap: `${gap}px` }}>
      {children}
    </div>
  );
};

export default BoxContent;
